import {
  OrganisationType,
  severity,
} from "@/api/mutation/useOrganisationMutation";
import useCurrentUserQuery from "@/api/query/useCurrentUserQuery";
import { OrgStatusEnumValue } from "@backend/src/schemas/enums";
import { updateOrganisationSchema } from "../../../../../backend/src/schemas/organisationSchema";
import { isAxiosError } from "axios";
import CreatableSelect from "react-select/creatable";
import { useFormik } from "formik";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import Select, { MultiValue, SingleValue } from "react-select";
import { toast } from "react-toastify";
import { toFormikValidationSchema } from "zod-formik-adapter";
import countries from "../../../assets/json/countries.json";
import useCsvUploadMutation from "@/api/mutation/useCsvUploadMutation";
import { CSVDownloadUrl } from "@/Environment";
import useOrganisationUpdateMutation from "@/api/mutation/useOrganisationUpdateMutation";
import { z } from "zod";
import InputText from "@/components/common/InputText";
import ErrorMessage from "@/components/common/ErrorMessage";
import { Button } from "@/components/ui/button";
import CSVIcon from "@/assets/svg/csvIcon.svg";
import DownLoadIcon from "@/assets/svg/DownLoad.svg";
import TrashCanSvg from "@/assets/svg/TrashCan.svg";
import { errorConfig } from "@/lib/toastError";
import { useTranslation } from "react-i18next";
import Dialog from "@/components/common/Dialog";
import InputNumber from "@/components/common/InputNumber";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import InfoCircle from "@/assets/svg/Info circle.svg";
import Table from "@/components/shared/Table";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import Loader from "@/components/common/Loader";
import AppClint from "../appClinte";
interface Props {
  editData?: OrganisationType & { userId: string };
  viewOnly: boolean;
  refetch: () => void;
  setvalidationError: (data:string) => void;
  valueChange: (data: boolean) => void;
  close: () => void;
  activeTab: number;
}

export type SubmitRef = {
  callSubmit: () => void;
};

type Options = { label: string; value: string };

export const OrganisationNoPopupForm = forwardRef<SubmitRef, Props>(
  (props, ref) => {
    useImperativeHandle(ref, () => ({
      callSubmit() {
        formik.handleSubmit();
      },
    }));
    const { viewOnly, editData, activeTab } = props;
    const labelStyle = "font-medium text-base text-gray-450/30";
    const inputStyle =
      "py-1.5 px-3 rounded-md border border-gray-100 mt-2 w-full ";

    const organisationUpdateMutation = useOrganisationUpdateMutation(
      editData && editData.organisationId ? editData.organisationId : ""
    );
    const { refetch } = useCurrentUserQuery();
    const [countryValue, setContryValue] = useState<SingleValue<Options>>();
    const [industryValue, setIndustryValue] = useState<SingleValue<Options>>();
    const [removeAll, setRemoveAll] = useState(false);
    const formik = useFormik<z.infer<typeof updateOrganisationSchema>>({
      initialValues: {
        organisationName: editData?.organisationName ?? "",
        industry: editData?.industry ?? "",
        status: editData?.status ?? OrgStatusEnumValue.ACTIVE,
        nonWorkingDays: editData?.nonWorkingDays ?? [],
        country: editData?.country ?? "",
        jobTitlesOfOrg: editData?.jobTitlesOfOrg ?? [],
        riskType: editData?.riskType ?? [],
        userId: editData?.userId ?? "",
        countryCode: editData?.countryCode ?? "",
        phoneNumber: editData?.phoneNumber ?? "",
        severityTypes: editData?.severityTypes.sort((a, b) => a.min - b.min),
      },
      validationSchema: toFormikValidationSchema(updateOrganisationSchema),
      onSubmit: (values, helper) => {
        organisationUpdateMutation.mutate(values, {
          onSuccess(data) {
            toast.success(data.data.message);
            props.close();
            refetch();
            props.refetch();
          },
          onError(error) {
            if (isAxiosError(error)) {
              if (
                error.response?.status === 400 &&
                error.response.data?.errors &&
                Array.isArray(error.response?.data.errors)
              ) {
                error.response.data.errors.map(
                  (item: { message: string; path: [string] }) => {
                    helper.setFieldError(item.path[0], item.message);
                  }
                );
              }
              if (!Array.isArray(error.response?.data.errors)) {
                toast.error(
                  errorKeyFormate(error.response?.data.message + ""),
                  errorConfig
                );
              }
            }
          },
        });
      },
    });
    useEffect(() => {
        props.setvalidationError(formik.errors.phoneNumber??"")
    }, [formik.errors])
    
    useEffect(() => {
      if (editData) {
        formik.setValues({
          country: editData.country,
          industry: editData.industry,
          nonWorkingDays: editData.nonWorkingDays,
          organisationName: editData.organisationName,
          status: editData?.status,
          jobTitlesOfOrg: editData.jobTitlesOfOrg ?? [],
          countryCode: editData.countryCode,
          phoneNumber: editData.phoneNumber,
          userId: editData.userId,
          riskType: editData.riskType ?? [],
          severityTypes: editData.severityTypes.sort((a, b) => a.min - b.min),
        });
        if (editData.industry) {
          setIndustryValue({
            value: editData.industry,
            label: editData.industry,
          });
        }
        const country = countries.find((item) => {
          if (editData.country === item.isoCode) {
            return { label: item.name, value: item.isoCode };
          }
        });
        if (country) {
          setContryValue({ label: country?.name, value: country?.isoCode });
        }
      }
    }, [editData]);
    const reactSelectStyle = {
      control: (
        provided: Record<string, unknown>,
        state: { isFocused: boolean }
      ) => ({
        ...provided,
        border: "1px solid #E7E7E7",
        paddingTop: "0.2rem",
        paddingBottom: "0.2rem",
        paddingLeft: "0.2rem",
        outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
        boxShadow: state.isFocused ? "0px 0px 0px #299d91" : "none",
        "&:hover": {
          outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
          boxShadow: "0px 0px 0px #299d91",
        },
      }),
      option: (
        provided: Record<string, unknown>,
        state: { isSelected: boolean }
      ) => ({
        ...provided,
        color: state.isSelected ? "white" : "black",
        background: state.isSelected ? "#299d91" : "white",
        "&:hover": {
          color: "white",
          background: "#299d9199",
        },
      }),
    } as const;
    const { t } = useTranslation();
    const reactSelectStyleWorkingDays = {
      control: (
        provided: Record<string, unknown>,
        state: { isFocused: boolean }
      ) => ({
        ...provided,
        border: "1px solid #E7E7E7",
        paddingTop: "0.2rem",
        paddingBottom: "0.2rem",
        paddingLeft: "0.2rem",
        outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
        boxShadow: state.isFocused ? "0px 0px 0px #299d91" : "none",
        "&:hover": {
          outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
          boxShadow: "0px 0px 0px #299d91",
        },
      }),
      option: (
        provided: Record<string, unknown>,
        state: { isSelected: boolean }
      ) => ({
        ...provided,
        color: state.isSelected ? "white" : "black",
        background: state.isSelected ? "#299d91" : "white",
        "&:hover": {
          color: "white",
          background: "#299d9199",
        },
      }),
      multiValueRemove: (base: Record<string, unknown>) => {
        return {
          ...base,
          display: viewOnly ? "none" : "flex",
          backgroundColor: "#787486",
          borderTopLeftRadius: "99px",
          borderBottomLeftRadius: "99px",
          borderTopRightRadius: "99px",
          borderBottomRightRadius: "99px",
          position: "absolute" as const,
          border: "1.5px solid white",
          padding: 0,
          top: "-4px",
          right: "-8px",
          zIndex: 0,
          width: "fit-content",
          color: "white",
          "&:hover": {
            backgroundColor: "#299d91aa",
          },
        };
      },
      multiValueLabel: (base: Record<string, unknown>) => {
        return {
          ...base,
          backgroundColor: "#299d91",
          color: "white",
          borderRadius: "5px",
          paddingTop: "0.2rem",
          paddingBottom: "0.2rem",
          paddingLeft: "0.5rem",
          paddingRight: "0.5rem",
          borderTopRightRadius: "5px",
          borderBottomRightRadius: "5px",
          opacity: 1,
        };
      },
      multiValue: (base: Record<string, unknown>) => ({
        ...base,
        position: "relative" as const,
        backgroundColor: `#299d91`,
        color: "white",
        borderRadius: "5px",
        borderTopRightRadius: "5px",
        borderBottomRightRadius: "5px",
        marginRight: "7px",
      }),
      dropdownIndicator: (base: Record<string, unknown>) => ({
        ...base,
        display: "none",
      }),
      indicatorSeparator: (base: Record<string, unknown>) => ({
        ...base,
        display: "none",
      }),
    } as const;

    const nonWorkingDays: Options[] = [
      { label: t("sunday"), value: "SUN" },
      { label: t("monday"), value: "MON" },
      { label: t("tuesday"), value: "TUE" },
      { label: t("wednesday"), value: "WED" },
      { label: t("thursday"), value: "THU" },
      { label: t("friday"), value: "FRI" },
      { label: t("saturday"), value: "SAT" },
    ];
    const industriesData: Options[] = [
      { label: t("Construction"), value: t("Construction") },
      { label: t("Educational_services"), value: t("Educational_services") },
      {
        label: t("Healthcare and Social assistance"),
        value: t("Healthcare and Social assistance"),
      },
      {
        label: t("Insurance, Banking, Finance"),
        value: t("Insurance, Banking, Finance"),
      },
      { label: t("Manufacturing"), value: t("Manufacturing") },
      { label: t("Marketing/PR"), value: t("Marketing/PR") },
      { label: t("Non-Profit"), value: t("Non-Profit") },
      {
        label: t("Technology & Telecommunication"),
        value: t("Technology & Telecommunication"),
      },
      { label: t("Others"), value: t("Others") },
    ];

    const contrysFn = () => {
      const value = countries.map((item) => {
        return { label: item.name, value: item.isoCode };
      });
      return value;
    };
    const handleCountry = (val: SingleValue<Options>) => {
      if (val) {
        setContryValue(val);
        formik.setFieldValue("country", val.value);
      }
    };
    const handleNonWorkingDays = (val: MultiValue<Options>) => {
      formik.setFieldValue(
        "nonWorkingDays",
        val.map((item) => item.value)
      );
    };
    const handleIndustries = (val: SingleValue<Options>) => {
      if (val) {
        setIndustryValue(val);
        formik.setFieldValue("industry", val.value);
      }
    };
    const csvUplodeRef = useRef<HTMLInputElement>(null);
    const csvUploadMutation = useCsvUploadMutation();

    const uploadCsv = () => {
      if (
        csvUplodeRef.current &&
        csvUplodeRef.current.files &&
        csvUplodeRef?.current?.files[0]
      ) {
        const formData = new FormData();
        formData.append("csv", csvUplodeRef?.current?.files[0]);
        csvUploadMutation.mutate(formData, {
          onSuccess(data) {
            toast.success(data.data.message);
            if (csvUplodeRef?.current) {
              csvUplodeRef.current.value = "";
            }
            refetch();
            props.refetch();
          },
          onError(error) {
            toast.error(
              errorKeyFormate(error.response?.data.message + ""),
              errorConfig
            );
          },
        });
      }
    };
    const downloadCsv = () => {
      const ac = document.createElement("a");
      ac.href = CSVDownloadUrl;
      ac.download;
      ac.click();
    };
    const downloadUplodedCsv = (url: string) => {
      const ac = document.createElement("a");
      ac.href = url;
      ac.download;
      ac.click();
    };
    function getFileNameFromURL(url: string) {
      const filenameWithEncoding = url.substring(url.lastIndexOf("/") + 1);
      const filename = decodeURIComponent(filenameWithEncoding);
      return filename.split("-")[filename.split("-").length - 1];
    }
    const contryCode = () => {
      const value = countries.map((item) => {
        return {
          label: "+" + item.phonecode + " " + item.name,
          value: "+" + item.phonecode,
        };
      });

      const seenValues = new Set();
      const uniqueArray = value
        .filter((item) => {
          if (seenValues.has(item.value)) {
            return false;
          }
          seenValues.add(item.value);
          return true;
        })
        .sort((a, b) => {
          const numA = parseInt(a.value.substring(1));
          const numB = parseInt(b.value.substring(1));
          return numA - numB;
        });

      return uniqueArray;
    };

    //   const handleKeyDown: KeyboardEventHandler = (event) => {
    //     if (!inputValue) return;
    //     switch (event.key) {
    //       case 'Enter':

    //         setInputValue('');
    //       case 'Tab':
    //         formik.setFieldValue(
    //             "jobTitlesOfOrg",
    //             value.map((d) => {
    //               return d.value;
    //             })
    //           );
    //         setInputValue('');
    //         event.preventDefault();
    //     }
    //   };
    useEffect(() => {
      if (editData) {
        props.valueChange(
          !Object.keys(formik.values).every((key) => {
            const formikValue =
              formik.values[key as keyof typeof formik.values];
            const editValue = editData[key as keyof typeof editData];
            return (
              JSON.stringify(formikValue) ===
              JSON.stringify(editValue == null ? [] : editValue)
            );
          })
        );
      }
    }, [formik.values]);
    const [updateSeverityOpen, setUpdateSeverityOpen] = useState<{
      type: "max" | "severity" | "min" | undefined;
      value: string | number | undefined;
      severityId: string | undefined;
      error: string | undefined;
    }>({
      type: undefined,
      value: "",
      severityId: "",
      error: "",
    });
    const handleUpdateSeverity = () => {
      const severity = formik.values.severityTypes?.find(
        (t) => t.severityId === updateSeverityOpen.severityId
      );

      if (severity && updateSeverityOpen.type && updateSeverityOpen.value) {
        let updatedValue =
          typeof updateSeverityOpen.value === "string"
            ? parseFloat(updateSeverityOpen.value)
            : updateSeverityOpen.value;

        const severityTypes = formik.values.severityTypes || [];

        const sortedSeverityTypes = [...severityTypes];

        const updatedSeverityTypes = sortedSeverityTypes.map((t, i, arr) => {
          if (
            t.severityId === updateSeverityOpen.severityId &&
            updateSeverityOpen.type == "max"
          ) {
            t = { ...t, max: updatedValue };
            for (let offset = 1; offset <= 2; offset++) {
              if (arr[i + offset]) {
                const newMin = updatedValue;
                const newMax = Math.min(updatedValue + 1, 16);

                arr[i + offset] = {
                  ...arr[i + offset],
                  min: newMin <= 16 ? newMin : 16,
                  max:
                    arr[i + offset].max <= newMin
                      ? newMax
                      : arr[i + offset].max,
                };

                updatedValue = arr[i + offset].max;
              }
            }
          }
          if (
            t.severityId === updateSeverityOpen.severityId &&
            updateSeverityOpen.type == "min"
          ) {
            t = { ...t, min: updatedValue };
          }
          if (t.type === "Moderate") {
            t.min = 1;
          }
          if (t.type === "Very Critical") {
            t.max = 16;
          }
          return t;
        });

        formik.setFieldValue("severityTypes", updatedSeverityTypes);
      }

      setUpdateSeverityOpen({
        type: undefined,
        value: "",
        severityId: "",
        error: "",
      });
    };
    const nonworkingSelect = useMemo(
      () => (
        <Select
          isDisabled={viewOnly}
          className={`${inputStyle} select !p-0`}
          onChange={handleNonWorkingDays}
          onBlur={() => formik.setTouched({ nonWorkingDays: true })}
          value={nonWorkingDays.filter((n) =>
            formik.values.nonWorkingDays?.some((o) => o == n.value)
          )}
          options={nonWorkingDays}
          placeholder="Non Working days"
          isMulti
          styles={reactSelectStyleWorkingDays}
        />
      ),
      [viewOnly, formik.values.nonWorkingDays]
    );
    return (
      <div className="p-1 w-full h-fit">
        {organisationUpdateMutation.isPending && (
          <Loader className="absolute h-full w-full top-0 left-0" />
        )}
        {activeTab == 1 && (
          <div className="text-left flex flex-col lg:flex-row gap-2 w-full">
            <div className="w-full">
              <label className={labelStyle}>{t("organisation_name")}</label>
              <span className="ml-0.5 text-red-500">*</span>
              <div className="flex flex-col">
                <InputText
                  disabled={viewOnly}
                  className={inputStyle}
                  name="organisationName"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.organisationName}
                  placeholder="Organisation Name"
                />
                <ErrorMessage>
                  {formik.touched.organisationName &&
                    formik.errors.organisationName}
                </ErrorMessage>
              </div>
            </div>
            <div className="w-full">
              <label className={labelStyle}>{t("industry")}</label>
              <span className="ml-0.5 text-red-500">*</span>
              <div className="flex flex-col">
                <Select
                  isDisabled={viewOnly}
                  className={`${inputStyle} select !p-0`}
                  onChange={handleIndustries}
                  onBlur={() => formik.setTouched({ industry: true })}
                  options={industriesData}
                  value={industryValue}
                  placeholder="Industry"
                  styles={reactSelectStyle}
                />
                <ErrorMessage>
                  {formik.touched.industry && formik.errors.industry}
                </ErrorMessage>
              </div>
            </div>
          </div>
        )}

        {activeTab == 1 && (
          <div className="text-left flex flex-col lg:flex-row gap-2 w-full">
            <div className="w-full">
              <div className="flex gap-2">
                <div className="w-1/2">
                  <label className={labelStyle}>{t("country_code")}</label>
                  <Select
                    className="mt-2"
                    onChange={(e) => {
                      formik.setValues((prevValues) => ({
                        ...prevValues,
                        countryCode: e?.value ? e.value : "",
                      }));
                    }}
                    onBlur={() => formik.setTouched({ countryCode: true })}
                    options={contryCode()}
                    value={{
                      label: contryCode().find(
                        (c) => c.value == formik.values.countryCode
                      )?.label,
                      value: formik.values.countryCode,
                    }}
                    defaultValue={{
                      label: contryCode().find(
                        (c) => c.value == formik.values.countryCode
                      )?.label,
                      value: formik.values.countryCode,
                    }}
                    isDisabled={viewOnly}
                    placeholder="Country Code"
                    name="countryCode"
                    menuPlacement="auto"
                    styles={reactSelectStyle}
                  />
                  <ErrorMessage>
                    {formik.touched.countryCode && formik.errors.countryCode}
                  </ErrorMessage>
                </div>
                <div className="w-1/2">
                  <label className={labelStyle}>{t("phone_number")}
                    <span className="ml-0.5 text-red-500">*</span>
                  </label>
                  <InputNumber
                    disabled={viewOnly}
                    name="phoneNumber"
                    placeholder="Phone Number"
                    className={inputStyle + " !mt-2"}
                    value={formik.values.phoneNumber ?? ""}
                    onChange={(e) => formik.setFieldValue("phoneNumber", e.target.value.toString())}
                    onBlur={formik.handleBlur}
                  />
                  <ErrorMessage>
                    {formik.errors.phoneNumber && t(formik.errors.phoneNumber)}
                  </ErrorMessage>
                </div>
              </div>
            </div>
            <div className="w-full">
              <label className={labelStyle}>{t("country")}</label>
              <span className="ml-0.5 text-red-500">*</span>
              <div className="flex flex-col">
                <Select
                  isDisabled={viewOnly}
                  className={`${inputStyle} select !p-0`}
                  onChange={handleCountry}
                  onBlur={() => formik.setTouched({ country: true })}
                  options={contrysFn()}
                  value={countryValue}
                  placeholder="Select country"
                  name="country"
                  styles={reactSelectStyle}
                />
                <ErrorMessage>
                  {formik.touched.country && formik.errors.country}
                </ErrorMessage>
              </div>
            </div>
          </div>
        )}
        {activeTab == 3 && (
          <div className="text-left flex flex-col lg:flex-row gap-2 w-full">
            <div className="w-full">
              <label className={labelStyle}>{t("non_working_days")}</label>
              <span className="ml-0.5 text-red-500">*</span>
              <div className="flex flex-col">
                {nonworkingSelect}
                <ErrorMessage>
                  {formik.touched.nonWorkingDays &&
                    formik.errors.nonWorkingDays}
                </ErrorMessage>
              </div>
            </div>
            <div className="w-full">
              <label className={labelStyle}>
                {t("job_titles")}/{t("roles_in_the_projects")}
              </label>
              <div className="relative w-full group">
                <CreatableSelect
                  isDisabled={viewOnly}
                  className="mt-2"
                  placeholder="Add a new role"
                  key={formik.values.jobTitlesOfOrg + ""}
                  styles={{
                    ...reactSelectStyleWorkingDays,
                  }}
                  onChange={(newValue, actions) => {
                    if (actions.action == "clear") {
                      setRemoveAll(true);
                    } else {
                      formik.setFieldValue(
                        "jobTitlesOfOrg",
                        newValue?.map((d) => {
                          return d.value;
                        })
                      );
                    }
                  }}
                  isMulti
                  value={formik.values.jobTitlesOfOrg?.map((e: string) => {
                    return { label: e, value: e };
                  })}
                  noOptionsMessage={(e) =>
                    (e.inputValue = t("Type in a job title and press Enter"))
                  }
                  options={formik.values.jobTitlesOfOrg?.map((e: string) => {
                    return { label: e, value: e };
                  })}
                />
              </div>
              <ErrorMessage>{formik.errors.jobTitlesOfOrg}</ErrorMessage>
            </div>
          </div>
        )}
        {activeTab == 3 && (
          <div className="pr-1 mb-3">
            <div className="w-1/2 mt-1.5">
              <label className={labelStyle}>{t("Leave and holidays")}</label>
              <input
                onChange={uploadCsv}
                type="file"
                accept=".csv"
                className="hidden"
                ref={csvUplodeRef}
              />
              <Button
                isLoading={csvUploadMutation.isPending}
                disabled={csvUploadMutation.isPending || viewOnly}
                variant={"outline"}
                onClick={() => csvUplodeRef.current?.click()}
                className="w-full border-2 py-5 mt-0.5 text-gray-600"
              >
                <div className="flex gap-2 items-center">
                  <img src={CSVIcon} /> {t("Upload/Replace_holidays_list")}
                </div>
              </Button>
              <ErrorMessage>
                {formik.touched.country && formik.errors.country}
              </ErrorMessage>
            </div>
            {activeTab == 3 && (
              <div className="flex  gap-2 items-center justify-between mt-3 w-full md:w-1/2  col-start-1">
                <Button
                  variant={"link"}
                  className="w-fit text-gray-600 justify-start"
                  type="button"
                  onClick={() => downloadCsv()}
                >
                  <div className="flex gap-2 ">
                    <img className="h-4 w-4" src={DownLoadIcon} />{" "}
                    {t("Download_sample_CSV")}
                  </div>
                </Button>
                {editData && editData.holidayCsvUrl && (
                  <Button
                    variant={"link"}
                    className="w-fit text-gray-600 justify-start"
                    type="button"
                    onClick={() =>
                      downloadUplodedCsv(editData.holidayCsvUrl ?? "")
                    }
                  >
                    <div className="flex gap-2 text-primary-400 ">
                      <img className="h-4 w-4" src={DownLoadIcon} />{" "}
                      {getFileNameFromURL(editData.holidayCsvUrl)}
                    </div>
                  </Button>
                )}
              </div>
            )}
          </div>
        )}
        {activeTab == 3 && (
          <div className="flex w-full items-start gap-2">
            <div className="flex w-1/2 items-start flex-col gap-2">
              <div className="w-full">
                <label className={labelStyle}>{t("Risk Type")}</label>
                <div className="relative w-full group">
                  <CreatableSelect
                    isDisabled={viewOnly}
                    className="mt-2"
                    placeholder="Add a new risk type"
                    key={formik.values.riskType + ""}
                    styles={{
                      ...reactSelectStyleWorkingDays,
                    }}
                    onChange={(newValue, actions) => {
                      if (actions.action == "clear") {
                        setRemoveAll(true);
                      } else {
                        formik.setFieldValue(
                          "riskType",
                          newValue?.map((d) => {
                            console.log({riskType:d.value});
                            return t(d.value);
                          })
                        );
                      }
                    }}
                    backspaceRemovesValue={false}
                    isMulti
                    value={formik.values.riskType?.map((e: string) => {
                      return { label: e, value: e };
                    })}
                    noOptionsMessage={(e) =>
                      (e.inputValue = t("Type in a risk type and press Enter"))
                    }
                    options={formik.values.riskType?.map((e: string) => {
                      return { label: e, value: e };
                    })}
                  />
                </div>
                <ErrorMessage>{formik.errors.riskType}</ErrorMessage>
              </div>
            </div>
            <div className="w-1/2">
              <label className={labelStyle + " flex items-center gap-1"}>
                {t("Risk severity")}
                <TooltipProvider delayDuration={0}>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <img src={InfoCircle} className="w-4 h-5" />
                    </TooltipTrigger>
                    <TooltipContent>
                      <div className="flex gap-1 justify-start flex-col items-start">
                        <div className="font-bold text-gray-500">
                          {t("severity")} = {t("impact")} * {t("probability")}
                        </div>
                        <div className="text-sm font-bold text-gray-500">
                          {t("impact is from 1 to 4")}
                        </div>
                        <div className="text-sm font-bold text-gray-500">
                          {t("probability is from 1 to 4")}
                        </div>
                        <div className="text-sm font-bold text-gray-500">
                          {t("severity is from 1 to 16")}
                        </div>
                      </div>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              </label>
              <Table
                hidePagination={true}
                className={`w-full h-full mt-2 !p-0 ${
                  viewOnly ? "opacity-80" : ""
                }`}
                data={formik?.values.severityTypes ?? []}
                columnDef={[
                  {
                    header: "Min",
                    key: "min",
                    onCellRender: (data: severity) => {
                      return (
                        <div
                          className={`w-full ${
                            !viewOnly && data.type !== "Moderate"
                              ? "cursor-pointer"
                              : ""
                          } text-center`}
                          onClick={() => {
                            !viewOnly && data.type !== "Moderate"
                              ? setUpdateSeverityOpen({
                                severityId: data.severityId,
                                type: "min",
                                value: undefined,
                                error: "",
                              })
                              : null;
                          }}
                        >
                          {updateSeverityOpen.severityId == data.severityId &&
                          updateSeverityOpen.type == "min" ? (
                              <div className="flex flex-col justify-center items-center">
                                <InputNumber
                                  autoFocus
                                  className="w-36"
                                  onKeyUp={(e) =>
                                    e.code == "Enter"
                                      ? handleUpdateSeverity()
                                      : ""
                                  }
                                  onBlur={() => handleUpdateSeverity()}
                                  onChange={(e) => {
                                    const index =
                                    formik.values.severityTypes?.findIndex(
                                      (t) => t.severityId == data.severityId
                                    ) ?? 0;
                                    if (
                                      Number(e.target.value) < 0 ||
                                    Number(e.target.value) > 16
                                    ) {
                                      setUpdateSeverityOpen((prev) => {
                                        return { ...prev, error: e.target.value };
                                      });
                                      formik.setFieldError(
                                        "severityTypes",
                                        `The value must be greater than or equal to 0 and less than 16`
                                      );
                                    } else if (
                                      Number(e.target.value) >= data.max
                                    ) {
                                      setUpdateSeverityOpen((prev) => {
                                        return { ...prev, error: e.target.value };
                                      });
                                      formik.setFieldError(
                                        "severityTypes",
                                        `The value must be greater than or equal to 0, and less than the maximum allowed value.`
                                      );
                                    } else if (
                                      formik.values.severityTypes &&
                                    index > 0 &&
                                    Number(e.target.value) <
                                      formik.values.severityTypes[index - 1].max
                                    ) {
                                      setUpdateSeverityOpen((prev) => {
                                        return { ...prev, error: e.target.value };
                                      });
                                      formik.setFieldError(
                                        "severityTypes",
                                        `value must be less then ${t(
                                          formik.values.severityTypes[index - 1]
                                            .type
                                        )} max value.`
                                      );
                                    } else {
                                      setUpdateSeverityOpen((prev) => {
                                        return {
                                          ...prev,
                                          value: e.target.value,
                                          error: "",
                                        };
                                      });
                                      formik.setFieldError(
                                        "severityTypes",
                                        undefined
                                      );
                                    }
                                  }}
                                />
                                <ErrorMessage className="text-xs">
                                  {formik.errors.severityTypes}
                                </ErrorMessage>
                              </div>
                            ) : (
                              <div
                                className={`${" underline-offset-2"} ${
                                  data.type !== "Moderate" || viewOnly
                                    ? "text-primary-500 underline"
                                    : "text-gray-500"
                                }`}
                              >
                                {data.min == -1 ? "-" : data.min}
                              </div>
                            )}
                        </div>
                      );
                    },
                  },
                  {
                    header: "< Severity ≤",
                    key: "type",
                    onHeaderRender: () => {
                      return (
                        <span className="flex items-center justify-center gap-1">
                          <span className="text-lg leading-3">&lt;</span>{" "}
                          <span>{t("severity")}</span>{" "}
                          <span className="text-xl leading-3">≤</span>
                        </span>
                      );
                    },
                    onCellRender: (data: severity) => {
                      return (
                        <div
                          className={`${
                            data.type == "Moderate"
                              ? "bg-[#fef08acc]"
                              : data.type == "Critical"
                                ? "bg-[#facc15cc]"
                                : "bg-[#ef444480]"
                          } px-1.5 py-1 rounded w-32`}
                        >
                          <div className="w-full  text-center">
                            {t(data.type)}
                          </div>
                        </div>
                      );
                    },
                  },
                  {
                    header: "Max",
                    key: "max",
                    onCellRender: (data: severity) => {
                      return (
                        <div
                          className={`w-full ${
                            !viewOnly && data.type !== "Very Critical"
                              ? "cursor-pointer"
                              : ""
                          } text-center`}
                          onClick={() => {
                            !viewOnly && data.type !== "Very Critical"
                              ? setUpdateSeverityOpen({
                                severityId: data.severityId,
                                type: "max",
                                value: undefined,
                                error: "",
                              })
                              : "";
                          }}
                        >
                          {updateSeverityOpen.severityId == data.severityId &&
                          updateSeverityOpen.type == "max" ? (
                              <div className="flex flex-col justify-center items-center">
                                <InputNumber
                                  autoFocus
                                  className="w-36"
                                  onKeyUp={(e) =>
                                    e.code == "Enter"
                                      ? handleUpdateSeverity()
                                      : ""
                                  }
                                  onBlur={() => handleUpdateSeverity()}
                                  onChange={(e) => {
                                    if (
                                      Number(e.target.value) < 0 ||
                                    Number(e.target.value) > 16
                                    ) {
                                      setUpdateSeverityOpen((prev) => {
                                        return { ...prev, error: e.target.value };
                                      });
                                      formik.setFieldError(
                                        "severityTypes",
                                        `The value must be greater than or equal to 0 and less than 16`
                                      );
                                    } else if (
                                      data.min > Number(e.target.value) &&
                                    data.min > 0
                                    ) {
                                      setUpdateSeverityOpen((prev) => {
                                        return { ...prev, error: e.target.value };
                                      });
                                      formik.setFieldError(
                                        "severityTypes",
                                        `Max value must be greater than to Min value.`
                                      );
                                    } else {
                                      setUpdateSeverityOpen((prev) => {
                                        return {
                                          ...prev,
                                          value: e.target.value,
                                          error: "",
                                        };
                                      });
                                      formik.setFieldError(
                                        "severityTypes",
                                        undefined
                                      );
                                    }
                                  }}
                                />
                                <ErrorMessage className="text-xs">
                                  {formik.errors.severityTypes}
                                </ErrorMessage>
                              </div>
                            ) : (
                              <div
                                className={`${" underline-offset-2"} ${
                                  data.type !== "Very Critical" || viewOnly
                                    ? "text-primary-500 underline"
                                    : "text-gray-500"
                                }`}
                              >
                                {data.max == -1 ? 16 : data.max}
                              </div>
                            )}
                        </div>
                      );
                    },
                  },
                ]}
              ></Table>
            </div>
          </div>
        )}
         {activeTab == 3 &&  <AppClint/>}

        <Dialog
          isOpen={Boolean(removeAll)}
          onClose={() => {}}
          modalClass="rounded-lg"
        >
          <div className="flex flex-col gap-2 p-6 ">
            <img src={TrashCanSvg} className="w-12 m-auto" />
            {t("common_delete_message")}
            <div className="flex gap-2 ml-auto">
              <Button variant={"outline"} onClick={() => setRemoveAll(false)}>
                {t("cancel")}
              </Button>
              <Button
                variant={"primary"}
                onClick={() => {
                  formik.setFieldValue("riskType", []);
                  setRemoveAll(false);
                }}
              >
                {t("delete")}
              </Button>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
);
